import { uri } from 'utils';

import types from '../types';

/**
 * @param {types.CheckBoxOrRadioOption[]} options
 * @returns {?string}
 */
const getURLValueFromActiveInputs = options => {
    if (!options || !Array.isArray(options) || !options.length) {
        return null;
    }

    const checkedOptions = [];

    // collect active options
    options.forEach(filter => {
        if (filter.checked) {
            checkedOptions.push(filter.id.toString());
        }

        if (filter.subOptions && filter.subOptions.length) {
            filter.subOptions.forEach(subOption => {
                if (subOption.checked) {
                    checkedOptions.push(subOption.id.toString());
                }
            });
        }
    });

    if (checkedOptions.length) {
        return checkedOptions.join(uri.VALUE_SEPARATOR);
    }

    return null;
};

export default getURLValueFromActiveInputs;
